import { Edit, CardActions, ListButton, RefreshButton } from "react-admin";
import React from "react";

import TypeForm from "./TypeForm";

const TypeTitle = ({ record }) => {
  return <span>แก้ไข {record ? `"${record.name}"` : ""}</span>;
};

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    <RefreshButton />
  </CardActions>
);

export const TypeEdit = props => {
  return (
    <Edit actions={<Actions />} title={<TypeTitle />} {...props}>
      <TypeForm />
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/components/type/TypeEdit.js